const translations = {
  "en": {
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "Confirm Permanent Account Deletion?": "Confirm Permanent Account Deletion?",
    "Deactivate account": "Deactivate account",
    "Deletion in Progress Your account will be closed within 7 business days. In the meantime, you can still use your account as usual.": "Deletion in Progress Your account will be closed within 7 business days. In the meantime, you can still use your account as usual.",
    "Deletion requested. 7 business days to process": "Deletion requested. 7 business days to process"
  },
  "zh-tw": {
    "Cancel": "取消",
    "Confirm": "確認",
    "Confirm Permanent Account Deletion?": "確認永久刪除帳戶？",
    "Deactivate account": "停用帳號",
    "Deletion in Progress Your account will be closed within 7 business days. In the meantime, you can still use your account as usual.": "刪除進行中 你的帳戶將在7個營業日內關閉。在此期間，你仍可正常使用你的帳戶。",
    "Deletion requested. 7 business days to process": "刪除請求。7個營業日處理時間"
  }
};

export default translations;
